import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { 
  Box,
  Container,
  Grid,
  Paper,
  Typography,
} from '@mui/material';

import portada2 from '../../assets/portada_02_820_514.jpg';
import portada3 from '../../assets/portada_03_820_514.jpg';
import portada4 from '../../assets/portada_04_820_514.jpg';
import portada5 from '../../assets/portada_05_820_514.jpg';
import portada6 from '../../assets/portada_06_820_514.jpg';

const HomePage = () => {
  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    arrows: false,
    cssEase: "linear"
  };
  return (
    <div className='page'>
      <div className='pageHeader'>Club Ajedrez Pensado</div>
      <div id='container' style={{paddingBottom: '1em'}}>


        <Box component="section" sx={{ py: 10, bgcolor: 'black', paddingTop:'1em' }}>
          <Container maxWidth="lg">
            <Box sx={{ textAlign: 'center', mb: 8 }}>
              <Typography variant="h4" component="h2" sx={{ color: 'text.primary', mb: 2 }}>
                Nuestra Historia
              </Typography>
              <Typography align='justify' marginBottom={'1em'} variant="body1" sx={{ color: 'text.secondary', maxWidth: '1200px', mx: 'auto' }}>
                  Somos un grupo de un grupo de ajedrecistas que, ante la falta de una actividad oficial constante, a principios de 2007 decidimos generar un espacio para el jugador de ajedrez en C&oacute;rdoba.
                  A partir de nuestra iniciativa, y con el apoyo de la Asociaci&oacute;n de Entidades de Ajedrez de la Ciudad de C&oacute;rdoba y del Sindicato de Luz y Fuerza, en enero del 2007 vio la luz el <strong>Club de Ajedrez Luz y Fuerza</strong>,
                  entidad a trav&eacute;s de la cual buscamos generar actividad oficial (tanto a nivel local como nacional) de calidad y sostenida en el tiempo que le permita al jugador de ajedrez - tanto federado como aficionado -
                  desarrollar su actividad y progresar en la misma.
              </Typography>
              <Typography align='justify' variant="body1" sx={{ color: 'text.secondary', maxWidth: '1200px', mx: 'auto' }}>
                  En el a&ntilde;o 2019, al no poder contar m&aacute;s con los espacios de la sede central del sindicato, el Club decidió emprender una aventura que lo llevaría a su refundación, con sede propia y con el apoyo de todos sus socios,
                  no socios y personas que colaboraron desinteresadamente para que el proyecto fuera posible. Desde ese momento, nuestro Club pas&oacute; a denominarse <b>Ajedrez Pensado</b> y poco a poco puso en marcha una gran variedad de actividades,
                  que realiza de manera continua y sostenida, con proyecci&oacute;n hacia un futuro de crecimiento en cantidad y calidad de sus propuestas. 
              </Typography>
            </Box>

            <div
              className='slider-container'
              style={{
                width: '850px',
                maxWidth: '100%',
                display: 'inline-block',
                paddingBottom: '1em',
                marginBottom: '1em',
                minWidth: 0,
                maxHeight: 0,
              }}
            >
              <Slider {...settings}>
                <div>
                  <img src={portada2} alt='Portada 1' />
                </div>
                <div>
                  <img src={portada3} alt='Portada 2'/>
                </div>
                <div>
                  <img src={portada4} alt='Portada 3'/>
                </div>
                <div>
                  <img src={portada5} alt='Portada 4'/>
                </div>
                <div>
                  <img src={portada6} alt='Portada 5'/>
                </div>
              </Slider>
            </div>

            <Grid container spacing={4} marginTop={5}>
              {['Actividades', 'Clases', 'Ranking'].map((title) => (
                <Grid item xs={12} md={4} key={title}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      bgcolor: 'grey.9',
                      height: '100%',
                    }}
                  >
                    <Typography variant="h6" sx={{ mb: 1.5 }}>
                      {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {title === 'Actividades' && (
                        "Gran variedad de actividades, que realiza de manera continua y sostenida todo el año."
                      )}
                      {title === 'Clases' && (
                        "Clases presenciales y virtuales con maestros de gran nivel nacional e internacional."
                      )}
                      {title === 'Ranking' && (
                        "Sistema de Ranking Unificado (proyecto G.R.A.U.) para todos los ajedrecistas cordobeses."
                      )}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>


      </div>
    </div>
  );
};

// <img src={portada1} alt='Portada 1'/>

export default HomePage;
